<template>
  <div class="login">
    <div class="login-modal">
      <h1>Авторизация</h1>
      <span>Для того, чтобы воспользоваться панелью администратора, Вам необходимо авторизоваться через GitLab</span>
      <button @click="auth" class="gitlab-button">
        <img class="gitlab-logo" src="@/assets/images/gitlab-logo.svg" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    async auth() {
      const appId = process.env.VUE_APP_GITLAB_APP_ID;
      const uri = `${location.protocol}//${location.host}/auth-callback`;
      const stateHash = 'randomhash'; // TODO: Сделать генерацию хэша, сохранение в localStorage и проверку в auth-callback

      window.location.href = `https://git.vwgroup.ru/oauth/authorize?scope=openid+email+profile&client_id=${appId}&redirect_uri=${uri}&response_type=code&state=${stateHash}`;
    },
  },
};
</script>


<style lang="scss" scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  h1 {
    font-size: 24px;
  }
}

.login-modal {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 370px;
  height: 180px;
  padding: 0 12px;
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  text-align: center;

  span {
    margin: 8px 0 14px;
  }
}

.gitlab-button {
  padding: 4px 14px;
  background: #3e1d56;
}

.gitlab-logo {
  width: 96px;
  height: 34px;
}
</style>
